module.exports = __webpack_public_path__ + "img/eicon2-1.861de17d.png";